import type { Example } from '@/types';

import { stringifySlateContent } from '../stringifySlateContent';
import type { Meta } from '../types/meta';

export function extractExampleMetadata(example: Example): Meta {
    const { title = '', meta, customer = '', path, slug } = example;

    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL ?? 'https://www.prezly.com';
    const canonicalUrl = new URL(path, websiteUrl).toString();

    return {
        title: meta?.title ?? (title && customer ? `${title} - ${customer}` : null),
        description: meta?.description ?? stringifySlateContent(example.description),
        twitterCardType: 'summary_large_image',
        shareImage: `/api/og/press-release-examples/${slug}`,
        canonicalUrl,
        noIndex: true,
    };
}
